<template>
  <div>
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon" style="top: 45%;">
          <v-icon>search</v-icon>
        </div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="filter.keyword"
        />
      </div>
      <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="篩選問與答類別"
          :isOnlyShowButtonPlaceholder="true"
          buttonWidth="300px"
          modalWidth="300px"
          :options="categories"
          :selectedValue.sync="filter.tab"
          item-value="id"
          item-text="title"
        >
      </SimpleSelectWithSearchInput>
      <TableControlShowState v-model="filter.status"></TableControlShowState>
      <button class="btn btn-primary w-88px" @click="getqaList">搜尋</button>
    </div>
    <!-- filter condition -->
    <div class="px-5 mb-5 d-flex" v-if="filter.tab != ''">
      <div
        class="h5 ink-02-medium--text h-32px w-70px d-flex align-center flex-shrink-0">
        篩選條件：
      </div>
      <div class="flex-wrap">
        <!-- filter faq category -->
        <v-chip
          v-if="filter.tab != null"
          close
          class="ml-5 mb-2"
          @click:close="filter.tab = null">
          {{ categoryName }}
        </v-chip>
      </div>
    </div>
    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px" @click="multiDelete">
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
          <div>
            <button class="btn mr-10px" @click="multiChangeStatus(true)">設為顯示</button>
          </div>
          <div>
            <button class="btn" @click="multiChangeStatus(false)">設為隱藏</button>
          </div>
        </div>
        <tr>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="col-qa-title text-left">標題</th>
          <th class="text-left">分類</th>
          <th class="text-left">顯示/隱藏</th>
          <th class="text-left">排序</th>
          <th class="text-left">編輯</th>
          <th class="text-left">刪除</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in qaList"
          :key="item.id"
        >
          <td>
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </td>
          <td>{{ item.title }}</td>
          <td>{{ item.faq_category.title }}</td>
          <td>
            <FormSwitch v-model="item.status"
                        @changeStatus="toggleStatus(item.id)"></FormSwitch>
          </td>
          <td>{{ item.order }}</td>
          <td>
            <button class="btn square" @click="toQAEdit(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </td>
          <td>
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="getqaList" model="resqa"></Pagination>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import TableControlShowState from '@/components/TableControlShowState.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    FormSwitch,
    Pagination,
    deleteDialog,
    SimpleSelectWithSearchInput,
    TableControlShowState,
  },
  data: () => ({
    checkAllStatus: false, // left top checkbox status
    selectedItems: [],
    categories: [],
    currentCatTabId: '',
  }),
  computed: {
    ...mapState('resqa', ['qaList', 'filter']),
    lengthOfisCheckedList() {
      return this.qaList.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.qaList.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.qaList.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.qaList.filter((item) => item.isChecked).map((item) => item.id);
    },
    categoryName() {
      const category =
        this.categories.find((item) => item.id === this.filter.tab);
      return category ? category.title : '';
    },
  },
  async created() {
    this.categories = await this.getQACates(this.currentCatTabId);
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.qaList.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.qaList.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    ...mapActions('resqa', {
      getqaList: 'find',
      destroyQA: 'destroy',
      setFilter: 'setFilter',
      clear: 'clear',
      changeStatus: 'changeStatus',
      getQACates: 'getQACates',
    }),
    toQAEdit(id) {
      this.$router.push({
        name: 'QAEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.qaList.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.qaList.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyQA(id).then(() => {
        this.getqaList();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyQA(id).then(() => {});
      });
      this.getqaList();
    },
    async multiChangeStatus(status) {
      await this.isCheckedListIds.forEach((id) => {
        this.changeStatus({
          id, status,
        }).then(() => {});
      });
      this.getqaList();
    },
    toggleStatus(id) {
      this.changeStatus({ id }).then(() => {
        this.getqaList();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  .col-date {
    width: 75px;
    margin-right: 40px;
  }
  .col-qa-title {
    width: 250px;
    margin-right: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .col-show {
    margin: 0 20px;
  }
}
</style>
